var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStealthIntellLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 350 1920 500",
    style: {
      enableBackground: "new 0 0 1920 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "652.59,587.39 294.39,485.23 373.27,587.39 294.39,690.23  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M626.39,545.23c0,0-11-82-80-139c0,0-56.85-53-141.43-55c0,0-72.57-11-155.57,53c0,0-86,63-86,183.5 c0,0-6,96.5,73,171.5c0,0,60.9,64.65,158.45,64.32c0,0,83.55,5.68,155.55-58.32c0,0,61-48,76-135.19l-71,23.19c0,0-36,101-150,107 c0,0-84,9-141-63c0,0-38.57-41-39.29-109.5c0,0-3.71-73.5,54.29-126.5c0,0,40-44,109-47c0,0,56-5,105,30c0,0,39,23,62,77 L626.39,545.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "709.39,622.23 644.39,801.76 630.08,801.76 694.8,622.23  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "737.36,622.42 672.36,801.95 658.04,801.95 722.76,622.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "818.88,622.23 753.88,801.81 739.56,801.81 804.29,622.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "738.36,622.42 723.76,622.42 739.35,801.76 753.67,801.76  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "878.84,622.98 813.84,802.51 799.52,802.51 864.25,622.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "830.25,622.52 822.9,641.73 908.9,641.73 916.21,622.52  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "944.75,622.89 879.75,802.43 865.43,802.43 930.15,622.89  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "930.15,622.89 992.06,622.89 984.8,641.75 925.38,641.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "903.47,698.41 964.39,698.41 956.68,716.75 898.2,716.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "873.07,783.35 934.98,783.73 928.25,802.72 868.83,802.36  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1024.92,622.7 959.92,802.23 945.6,802.23 1010.33,622.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "952.71,783.3 1014.61,783.3 1007.4,802.22 947.98,802.22  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1175.69,623 1110.69,802.53 1096.38,802.53 1161.1,623  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1268.47,648.84l9.26-18.47c0,0-20.2-18.11-58.22,0c0,0-23.39,11.16-42.14,39.94c0,0-12.21,17.93-20.64,43.21 c0,0-7,21.74-7.97,37.4c0,0-1.84,18.66,3.45,30.56c0,0,6.02,22.47,34.49,22.15c0,0,16.95,0.39,36.42-9.4l31.01-85.38h-39.24 l-6.55,17.93h24.57l-19.33,53.12c0,0-6.02,4.53-19.63,5.03c0,0-40.03,4.42-25.35-57.09c0,0,8.04-37.95,33.47-65.11 c0,0,19.29-22.04,42.66-21.63C1244.76,641.12,1258.54,640.27,1268.47,648.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1393.08,623.17 1328.08,802.7 1313.77,802.7 1378.49,623.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1474.6,622.98 1409.6,802.56 1395.29,802.56 1460.01,622.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1394.08,623.17 1379.49,623.17 1395.08,802.52 1409.4,802.52  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1565.57,649.11c0,0-6.35-7.55-22.03-7.13c0,0-18.66-1.22-39.73,19.43c0,0-22.83,19.68-35.46,65.99 c0,0-17.49,56.95,22.48,56.59c0,0,13.72,1,27.82-7.42l-2.47,17.44c0,0-14.17,8.62-33.62,8.31c0,0-49.69,4.52-30.89-71.97 c0,0,11.14-51.06,47.24-83.53c0,0,23.73-23.68,51.68-23.24c0,0,17.6-0.24,24.18,8.32L1565.57,649.11z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1100.55,622.54 1035.55,802.08 1021.23,802.08 1085.95,622.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1028.33,783.14 1090.24,783.14 1083.03,802.07 1023.61,802.07  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1315.1,623.19 1250.1,802.72 1235.78,802.72 1300.5,623.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1300.5,623.19 1362.41,623.19 1355.15,642.04 1295.73,642.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1273.82,698.7 1334.74,698.7 1327.03,717.05 1268.55,717.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1243.42,783.65 1305.33,784.03 1298.6,803.02 1239.18,802.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1608.43,623.19 1543.43,802.72 1529.12,802.72 1593.84,623.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1593.84,623.19 1655.74,623.19 1648.48,642.04 1589.06,642.04  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1567.15,698.7 1628.08,698.7 1620.37,717.05 1561.88,717.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1536.75,783.65 1598.66,784.03 1591.94,803.02 1532.51,802.65  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M690.17,585.75c0,0-3.77-4.52,81.23-4.52h790.49c0,0,91.47,0.04,94.49,4.52c0,0,3.02,4.48-94.49,4.36H770.92 C770.92,590.11,693.94,590.27,690.17,585.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M664,521.84l22.94-17.72c0,0,7.36,10.75,20.54,17.34c0,0,9.88,5.36,25.51,5.36c0,0,14.96,0.85,25.69-8.38 c0,0,7.15-5.74,7.15-15.34c0,0,1.51-7.72-10.26-14.31c0,0-0.66-1.41-20.99-9.79c0,0-14.49-6.02-23.53-14.21 c0,0-10.07-8.09-10.07-23.91c0,0-0.56-13.08,7.81-25.88c0,0,6.02-10.64,19.48-18.16c0,0,16.28-9.98,39.25-9.79 c0,0,14.21-0.19,29.36,4.89c0,0,15.62,5.18,27.01,19.01l-21.55,19.48c0,0-10.16-11.58-22.02-15.34c0,0-4.89-2.45-17.69-2.82 c0,0-11.67-0.94-22.31,6.4c0,0-8.94,6.21-9.04,15.91c0,0-0.28,6.49,5.46,10.73c0,0,2.64,2.16,8.94,5.65c0,0,7.72,3.76,11.76,5.36 c0,0,4.42,1.6,10.45,4.33c0,0,10.73,4.52,17.6,11.2c0,0,11.29,8.85,11.11,24.66c0,0,0,11.95-5.18,21.93c0,0-4.52,8.56-9.88,13.55 c0,0-7.81,8-18.73,12.89c0,0-14.12,7.25-33.6,6.96c0,0-19.86,0.75-37.65-7.06C691.58,544.8,674.45,538.21,664,521.84z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "844.42,549.51 872.73,549.51 920.66,415.67 971.29,415.67 980.71,389.23 850.75,389.23 841.25,415.6  892.24,415.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "944.9,549.51 1063.67,549.51 1072.82,524.12 982.12,524.12 997.25,481.39 1076.52,481.39  1085.55,456.4 1006.21,456.4 1021.04,414.69 1110.4,414.69 1119.58,389.27 1001.91,389.27  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1235.2,388.29h-27.11l-127.83,161.22h30.64l30.11-38.59h75.65l2.64,38.59h28.89L1235.2,388.29z M1160.8,485 l49.41-63.67l4.94,63.67H1160.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1266.75,549.44 1379.27,549.44 1388.66,523.81 1304.59,523.81 1352.45,389.22 1323.91,389.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1417.27,549.46 1445.69,549.46 1493.55,415.62 1544.35,415.62 1553.56,389.23 1423.64,389.23  1414.21,415.6 1465.11,415.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1517.76,549.46 1546.28,549.46 1570.35,482.12 1645.18,482.12 1621.27,549.46 1649.6,549.46  1706.69,389.24 1678.39,389.24 1654.6,455.94 1579.67,455.94 1603.26,389.24 1574.72,389.24  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStealthIntellLogoWhite);
export default __webpack_public_path__ + "static/media/StealthIntellLogo-White.2a66d47316f7e7a2edf0087e54d42789.svg";
export { ForwardRef as ReactComponent };